import React, { Component } from 'react';
import PropTypes from 'prop-types';
import create360Viewer from '360-image-viewer';
import canvasFit from 'canvas-fit';
import { set } from 'ol/transform';
 
class Viewer360 extends Component{

    constructor(props){
        super(props);
        
        this.state = {
            image: null,
            viewer: null,
            fadeIn: false,
            zoom: 62
        }

        this.canvasRef = React.createRef();
    }

    touchStart = event => {

        event.preventDefault()
    
        if(event.type.indexOf('touch') === 0 && event.touches.length == 2){
          this.startTouchDistance = Math.sqrt(Math.pow(event.touches[1].clientX - event.touches[0].clientX, 2) + Math.pow(event.touches[1].clientY - event.touches[0].clientY, 2));
        }
    
      }
    
      touchMove = event => {
    
        // multitouch
        if(event.type.indexOf('touch') === 0 && event.touches.length == 2){
    
          this.touchDistance = Math.sqrt(Math.pow(event.touches[1].clientX - event.touches[0].clientX, 2) + Math.pow(event.touches[1].clientY - event.touches[0].clientY, 2));
    
          let zoom = this.newTouchDistance - this.touchDistance > 0 ? 1 : -1
    
          this.touchCenter = [Math.abs(event.touches[1].clientX - event.touches[0].clientX), Math.abs(event.touches[1].clientY - event.touches[0].clientY)];

          this.setState(prevState => ({
            zoom: prevState.zoom + zoom
          }),
          ()=> {
              //console.log(zoom)
              console.log(this.state.zoom)
            if(this.state.zoom < 80 && this.state.zoom > 40){
                this.viewer.camera.fov = this.state.zoom * Math.PI / 180
            }
            else if(this.state.zoom > 80){
                this.setState({
                    zoom: 80
                })
            }
            else if(this.state.zoom < 40){
                this.setState({
                    zoom: 40
                })
            }
          })
    
          this.newTouchCenter = this.touchCenter;
          this.newTouchDistance = this.touchDistance;
    
        } 
      }
    
      touchEnd = event => {
        event.preventDefault()
        this.pointerPosition = null
      }

    componentDidMount(){
        //console.log('mounted 360')
        this.setState(prevState => ({
            image: this.props.path
            
        }))
    }

    componentDidUpdate( prevProps, prevState){
        
        let { path } = this.props;

        if(prevState.image === path){
            return;
        }

        //console.log('360 path: ', path)

        const image = new Image();
        image.src = path;

        
        image.onload = () => {
            // when the image is loaded, setup the viewer
            this.viewer = create360Viewer({
                image: image,
                canvas: this.canvasRef.current,
                theta: (1.25) * Math.PI / 2,
                phi: Math.PI * .485,
                rotateSpeed: -0.15,
                fov: this.state.zoom * Math.PI / 180
            });
            
            // attach canvas to body
            //document.body.appendChild(viewer.canvas);
            
            // setup fullscreen canvas sizing
            const fit = canvasFit(this.viewer.canvas, window, window.devicePixelRatio);
            window.addEventListener('resize', fit, false);
            window.addEventListener('wheel', e => {
                console.log(e)
                this.setState(prevState => ({
                    zoom: prevState.zoom + (e.deltaY) / 80
                }),
                () => {
                    if(this.state.zoom < 80 && this.state.zoom > 40){
                        this.viewer.camera.fov = this.state.zoom * Math.PI / 180
                        console.log(this.state.zoom, this.viewerRef)
                    }
                    else if(this.state.zoom > 80){
                        this.setState({
                            zoom: 80
                        })
                    }
                    else if(this.state.zoom < 40){
                        this.setState({
                            zoom: 40
                        })
                    }
                    //this.viewerRef.render()
                })
            })
            document.getElementById("canvas-360").addEventListener('touchstart', this.touchStart);
            document.getElementById("canvas-360").addEventListener('touchmove', this.touchMove);
            document.getElementById("canvas-360").addEventListener('touchend', this.touchEnd);
            
            fit();
            
            // start the render loop
            this.viewer.start();
        
            this.setState({
                fadeIn: true
            })

            setTimeout(() => {
                this.props.onReady();    
            }, 1000);
            

            
        };

    }

    render() {
        return (
            <div>
                <canvas 
                className={this.state.fadeIn ? "canvas360 fadeIn" : 'canvas360'}
                ref={this.canvasRef}
                id="canvas-360"/>
            </div>
        );
      
    }
}

Viewer360.propTypes = {
    path: PropTypes.string,
    onReady: PropTypes.func
}

Viewer360.defaultProps = {
    path: undefined,
    onReady: () => {}
}

export default Viewer360;